<template>
  <van-action-sheet 
    v-model="show" 
    title="选择疫苗"
    :closeable="false"
    class="action"
  >
    <div class="main">
      <div class="cate one" v-if="immunizationPlanning.length">
        <van-divider>
          <span class="text">免疫规划疫苗（免费）</span>
        </van-divider>
        <div class="list">
          <div 
            :class="['item', {current: index == n1}]"
            v-for="(item, index) in immunizationPlanning"
            :key="index"
            @click="change(index, 'immunizationPlanning')"
          >
            <div class="top">
              <b class="my-b">{{ item.vaccineName }}</b>
              <van-tag plain type="success" class="tag">{{ item.sellPriceDes }}</van-tag>
            </div>
            <div class="my-text">{{ item.manufacturer }}</div>
          </div>
        </div>
      </div>

      <div class="cate two" v-if="notImmunizationPlanning.length">
        <van-divider>
          <span class="text">非免疫规划疫苗（自费）</span>
        </van-divider>
        <div class="list">
          <div 
            :class="['item', {current: index == n2}]"
            v-for="(item, index) in notImmunizationPlanning"
            :key="index"
            @click="change(index, 'notImmunizationPlanning')"
          >
            <div class="top">
              <b class="my-b">{{ item.vaccineName }}</b>
              <span class="price">{{ item.sellPriceDes }}</span>
            </div>
            <div class="my-text">{{ item.manufacturer }}</div>
          </div>
        </div>
      </div>
      <div class="more" v-if="isShow">
        <span @click="showMore">查看更多</span>
      </div>
      <!-- <div class="btns">
        <van-button round @click="close">取消</van-button>
        <van-button type="info" round @click="confirm">确定</van-button>
      </div> -->
    </div>
  </van-action-sheet>
</template>

<script>
import { validateImm } from 'api/appointment'

export default {
  computed: {
    isShow() {
      const actualTotal = [...this.store1, ...this.store2]
      const showTotal = [...this.immunizationPlanning, this.notImmunizationPlanning]
      if (actualTotal.length <= 4 || showTotal.length > 4) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.n1 = -1
        this.n2 = -1
        this.data = null
      }
    }
  },
  data() {
    return {
      show: false,
      immunizationPlanning: [],
      notImmunizationPlanning: [],
      n1: -1,
      n2: -1,
      store1: [],
      store2: [],
      data: null
    }
  },
  methods: {
    // 初始数据处理
    open(data) {
      this.show = true
      this.store1 = data.filter(v => v.immunizationPlanning)
      this.store2 = data.filter(v => v.notImmunizationPlanning)
      this.immunizationPlanning = this.store1.length > 2 ? this.store1.slice(0,2) : this.store1
      this.notImmunizationPlanning = this.store2.length > 2 ? this.store2.slice(0,2) : this.store2
      // 处理默认选中
      if (this.immunizationPlanning.length) {
        this.n1 = 0
        this.data = this.immunizationPlanning[0]
      }
    },
    // 选中高亮
    change(index, type) {
      if (type == 'immunizationPlanning') {
        // if (this.n1 == index) return
        this.n1 = index
        this.n2 = -1
        this.data = this.immunizationPlanning[index]
        if (!this.data.storeNum) {
          this.$toast('该门诊暂无库存，请切换疫苗后预约')
          this.$store.commit('setVacc', null)
          return
        }
        this.validate()
      } else {
        // if (this.n2 == index) return
        this.n2 = index
        this.n1 = -1
        this.data = this.notImmunizationPlanning[index]
        this.data.vaccineSupId = this.$parent.vaccineSupId
        this.$store.commit('setVacc', this.data)
        if (!this.data.storeNum) {
          this.$toast('该门诊暂无库存，请切换疫苗后预约')
          this.$store.commit('setVacc', null)
          return
        }
        setTimeout(() => {
          this.$router.push('/appointment')
        }, 300)
      }
    },
    // 选中免规苗时的校验
    validate() {
      const params = {
        profileCode: this.$parent.profileCode,
        vaccineSupId: this.$parent.vaccineSupId
      }
      validateImm(params).then(res => {
        if (res.code !== 0) {
          this.$toast(res.message)
        } else {
          this.data.vaccineSupId = this.$parent.vaccineSupId
          this.$store.commit('setVacc', this.data)
          this.$router.push('/appointment')
        }
      })
    },
    // 更多
    showMore() {
      this.immunizationPlanning = this.store1
      this.notImmunizationPlanning = this.store2
    },
    // 确认选择
    // confirm() {
    //   if (!this.data) {
    //     return this.$toast('请选择疫苗')
    //   }
    //   if (!this.data.storeNum) {
    //     return this.$toast('暂无库存')
    //   }
    //   this.$store.commit('setVacc', this.data)
    //   this.$router.push('/appointment')
    // },
    // close() {
    //   this.show = false
    // }
  }
}
</script>

<style lang="less" scoped>
.action {
  height: 80%;
}
.main {
  padding: 0 13px 13px 13px;
  .cate {
    margin-bottom: 13px;
    .text {
      font-size: 12px;
      color: #999;
      font-weight: 500;
      opacity: .85;
    }
    .list {
      .item {
        height: 56px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 0 11px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        margin-bottom: 11px;
        &:last-child {
          margin-bottom: 0;
        }
        .top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .my-b {
            flex: 4,
          }
          .price {
            flex: 1;
            text-align: right;
            color: var(--orange);
            font-weight: bold;
            opacity: .9;
          }
        }
      }
      .current {
        border-color: var(--blue);
      }
    }
  }
  .more {
    text-align: center;
    color: var(--blue);
    font-size: 12px;
    font-weight: 500;
    opacity: .85;
    margin-bottom: 18px;
  }
  .btns {
    width: 100%;
    height: 85px;
    padding: 0 13px;
    box-sizing: border-box;
    background: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-button {
      width: 49%;
    }
  }
}
</style>